import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AbstractCycleDateWindowService } from '../abstraction/abstract.cycle-date-window.service';
import { CurrentCycleWindow } from '../../interfaces/current-cycle-window/current-cycle-window';

@Injectable({
  providedIn: 'root',
})
export class MockRtpCycleDateService extends AbstractCycleDateWindowService {
  private getCurrentCycleWindowJson =
    'assets/mocks/rtp/currentcyclewindow/getCurrentCycleWindow.json';

  constructor(private http: HttpClient) {
    super();
  }

  getCurrentCycleDateWindow(): Promise<CurrentCycleWindow | undefined> {
    return lastValueFrom(this.http.get<CurrentCycleWindow>(this.getCurrentCycleWindowJson));
  }
}
